/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the target operation.
 */
export type RolloutTargetOperationStatus = 'SUCCESS' | 'FAILED';

export const RolloutTargetOperationStatus = {

    SUCCESS: 'SUCCESS' as RolloutTargetOperationStatus,

    FAILED: 'FAILED' as RolloutTargetOperationStatus
};

